document.querySelectorAll("[data-format]").forEach( el => {
    const number = parseInt(el.innerText);
    const formattedNumber = number.toLocaleString('en-US', { maximumFractionDigits: 0 });
    el.innerText = formattedNumber
});

// Get the current year dynamically
const dateList = document.querySelectorAll("#currentYear");
for (let i = 0; i < dateList.length; i++) {
    dateList[i].textContent = new Date().getFullYear();
}

window.addEventListener('scroll', () => {
    const screenWidth = window.innerWidth;
    const bannerSlider = document.querySelector("[data-banner-slider]")
    const bannerContent = document.querySelector("[data-banner-content]")

    if (screenWidth < 992) {
        if (window.scrollY >= 42) {
            bannerSlider.style.position = 'fixed';
            bannerSlider.style.top = `42px`;
            bannerContent.style.marginTop = `${bannerSlider.offsetHeight}px`;
            bannerContent.style.position = "relative";
            bannerContent.style.zIndex = "1";
            bannerContent.style.backgroundColor = "#fff";
        } else {
            bannerSlider.style.position = '';
            bannerSlider.style.top = `0px`;
            bannerContent.style.marginTop = `2px`;
        }

        if (window.scrollY >= bannerSlider.offsetHeight) {
          bannerSlider.style.visibility = "hidden";
        } else  {
          bannerSlider.style.visibility = "visible";
        }
    } else {
        bannerSlider.style.position = 'unset';
        bannerSlider.style.top = `42px`;
        bannerContent.style.marginTop = "0px";
        bannerContent.style.position = "relative";
        bannerContent.style.zIndex = "1";
        bannerContent.style.backgroundColor = "#fff";

    }
});


/** START : PRODUCT SLIDER **************************************************/
const bannerSection = document.querySelector("#banner");
const panelSection = document.querySelector("#product-panel");

// Initialize each Swiper with scoped navigation elements
const bannerSwiper = new Swiper("#banner .bannerMain", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    prevEl: bannerSection.querySelector("[data-banner-navigation='prev']"),
    nextEl: bannerSection.querySelector("[data-banner-navigation='next']"),
  }
});

const panelSwiper = new Swiper("#product-panel .bannerMain", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    prevEl: panelSection.querySelector("[data-banner-navigation='prev']"),
    nextEl: panelSection.querySelector("[data-banner-navigation='next']"),
  }
});

// Thumbnail nodes per section
const bannerThumbs = bannerSection.querySelectorAll(".banner-gallery .banner-slide");
const panelThumbs = panelSection.querySelectorAll(".banner-gallery .banner-slide");

function updateBannerThumbs(activeIndex) {
  bannerThumbs.forEach(el => el.classList.remove("active"));
  if (bannerThumbs[activeIndex]) bannerThumbs[activeIndex].classList.add("active");
}

function updatePanelThumbs(activeIndex) {
  panelThumbs.forEach(el => el.classList.remove("active"));
  if (panelThumbs[activeIndex]) panelThumbs[activeIndex].classList.add("active");
}

// Keep thumbs in each section in sync with its own slider only
bannerSwiper.on('slideChange', () => {
  const idx = bannerSwiper.realIndex;
  updateBannerThumbs(idx);
});

panelSwiper.on('slideChange', () => {
  const idx = panelSwiper.realIndex;
  updatePanelThumbs(idx);
});

// Clicking thumbs controls only its own slider
bannerThumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => {
    bannerSwiper.slideToLoop(index);
    updateBannerThumbs(index);
  });
});

panelThumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => {
    panelSwiper.slideToLoop(index);
    updatePanelThumbs(index);
  });
});
/** END : PRODUCT SLIDER **************************************************/


/** START: PRODUCT PANEL **************************************************/
const panels = document.querySelectorAll("[data-product='panel']");

const setOptionDisplay = (panelEl, data) => {
  const listItemEls = panelEl.querySelectorAll("[data-list] > li");
  data.forEach((item, idx) => {
    const row = listItemEls[idx];
    if (!row) return;
    const priceEl = row.querySelector("[data-price]");
    if (priceEl) priceEl.innerText = item.price;
  });
};

const setChooseDisplay = (panelEl, selected) => {
  const chooseText = panelEl.querySelector("[data-choose='text']");
  const choosePrev = panelEl.querySelector("[data-choose='prev']");
  const chooseNew = panelEl.querySelector("[data-choose='new']");
  const chooseSave = panelEl.querySelector("[data-choose='save']");

  if (chooseText) chooseText.innerText = "Total";
  if (choosePrev) choosePrev.innerText = selected?.prevPrice ?? "";
  if (chooseNew) chooseNew.innerText = selected?.newPrice ?? "";
  if (chooseSave) chooseSave.innerText = selected?.discount ?? "";
};

const setProductLink = (panelEl, link) => {
  const cta = panelEl.querySelector("[data-product='cta']");
  if (cta) cta.setAttribute("href", link + newhref);
};

const setSliderActiveForPanel = (panelEl, activeTabEl) => {
  const sliderEl = panelEl.querySelector(".slider");
  if (!sliderEl || !activeTabEl) return;
  sliderEl.style.width = `${activeTabEl.offsetWidth}px`;
  sliderEl.style.transform = `translateX(${activeTabEl.offsetLeft}px)`;
};

var qparam = window.location.search;
qparam = qparam.replace("?", "");
let newhref = "";

// Use the first CTA found to determine if we append ? or &
const firstCta = document.querySelector("[data-product='cta']");
if (firstCta && firstCta.getAttribute("href") && firstCta.getAttribute("href").indexOf('?') >= 0) newhref = "&" + qparam;
else newhref = "?" + qparam;

const optionList = [
  [
    { price: "$41.65", discount: "$344.10", link: "https://go.ketoactivate.com/products/ka-6-pack-sub-ka-pdp-email", prevPrice: "$594", newPrice: "$249.90" },
    { price: "$50.15", discount: "$146.55", link: "https://go.ketoactivate.com/products/ka-3-pack-sub-ka-pdp-email", prevPrice: "$297", newPrice: "$150.45" },
    { price: "$58.65", discount: "$40.35", link: "https://go.ketoactivate.com/products/ka-1-pack-sub-ka-pdp-email", prevPrice: "$99", newPrice: "$63.60" },
  ],
  [
    { price: "$49", discount: "$300", link: "https://go.ketoactivate.com/products/ka-6-pack-ss-ka-pdp-email", prevPrice: "$594", newPrice: "$294" },
    { price: "$59", discount: "$120", link: "https://go.ketoactivate.com/products/ka-3-pack-ss-ka-pdp-email", prevPrice: "$297", newPrice: "$177" },
    { price: "$69", discount: "$30", link: "https://go.ketoactivate.com/products/ka-1-pack-ss-ka-pdp-email", prevPrice: "$99", newPrice: "$73.95" },
  ],
];

let isOneTime = false; // false => tab1 (Subscribe), true => tab2 (One-Time)
let selectedOptionIndex = 0; // 0,1,2 for the three options

const updateAllPanels = () => {
  const optionData = isOneTime ? optionList[1] : optionList[0];
  const selected = optionData[selectedOptionIndex];

  panels.forEach(panel => {
    // Tabs
    const tab1 = panel.querySelector('.tab-button[data-tab="tab1"]');
    const tab2 = panel.querySelector('.tab-button[data-tab="tab2"]');
    panel.classList.toggle('one-time', isOneTime);
    [tab1, tab2].forEach(t => t && t.classList.remove('active'));
    const activeTab = isOneTime ? tab2 : tab1;
    if (activeTab) activeTab.classList.add('active');
    setSliderActiveForPanel(panel, activeTab);

    // Options
    const optionEls = panel.querySelectorAll('[data-option]');
    optionEls.forEach(el => el.classList.remove('active'));
    const activeOption = panel.querySelector(`[data-option="${selectedOptionIndex + 1}"]`);
    if (activeOption) activeOption.classList.add('active');

    // Update supply text and hide/show span tags based on tab selection
    const optionElements = panel.querySelectorAll('[data-option]');
    optionElements.forEach((optionEl, index) => {
      // Find the text element within each option
      const productValueDiv = optionEl.querySelector('.product-value');
      if (productValueDiv) {
        const textEl = productValueDiv.querySelector('div.font-myriad-pro');
        if (textEl) {
          if (isOneTime) {
            // Change text to tubs format
            if (index === 0) textEl.innerHTML = '6 Tubs';
            else if (index === 1) textEl.innerHTML = '3 Tubs';
            else if (index === 2) textEl.innerHTML = '1 Tub';
          } else {
            // Restore original text
            if (index === 0) textEl.innerHTML = '6-Month Supply <span class="text-[12px] text-[#2D433D] font-normal">(6 Tubs)</span>';
            else if (index === 1) textEl.innerHTML = '3-Month Supply <span class="text-[12px] text-[#2D433D] font-normal">(3 Tubs)</span>';
            else if (index === 2) textEl.innerHTML = '1-Month Supply <span class="text-[12px] text-[#2D433D] font-normal">(1 Tub)</span>';
          }
        }
      }
    });

    // Prices and choose area
    setOptionDisplay(panel, optionData);
    setChooseDisplay(panel, selected);
    setProductLink(panel, selected?.link ?? "");
  });
};

// Wire events per panel but drive shared state
panels.forEach(panel => {
  const tabButtons = panel.querySelectorAll('.tab-button');
  tabButtons.forEach(tab => {
    tab.addEventListener('click', () => {
      isOneTime = tab.dataset.tab === 'tab2';
      updateAllPanels();
    });
  });

  const optionEls = panel.querySelectorAll('[data-option]');
  optionEls.forEach(opt => {
    opt.addEventListener('click', () => {
      const idx = Number(opt.dataset.option) - 1;
      if (!isNaN(idx)) selectedOptionIndex = idx;
      updateAllPanels();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  updateAllPanels();
});
/** END: PRODUCT PANEL **************************************************/


/** START: SUPPLEMENT FACTS POPUP MODAL *********************************/
// Get all supplement modal buttons
const supplementModalButtons = document.querySelectorAll("[data-modal='supplement']");

// Add click event listeners to all supplement modal buttons
supplementModalButtons.forEach(button => {
    button.addEventListener("click", (el) => {
        toggleModal(el.currentTarget.dataset.modal);
    });
});

// Add close button event listener
const closeButton = document.querySelector("[data-modal-cta='close']");
if (closeButton) {
    closeButton.addEventListener("click", (el) => {
        toggleModal(el.currentTarget.closest(".c-modal").dataset.modalTarget);
    });
}

// Add click outside modal to close
const modal = document.querySelector("[data-modal-target='supplement']");
if (modal) {
    modal.addEventListener("click", (el) => {
        if (el.target === modal) {
            toggleModal("supplement");
        }
    });
}

// Add escape key to close modal
document.addEventListener("keydown", (el) => {
    if (el.key === "Escape") {
        const openModal = document.querySelector(".c-modal.show");
        if (openModal) {
            toggleModal(openModal.dataset.modalTarget);
        }
    }
});

const toggleModal = (modal) => {
    const modalEl = document.querySelector(`[data-modal-target="${modal}"]`);
    if (modalEl) {
        modalEl.classList.toggle("hidden");
        modalEl.classList.toggle("show");
    }
}
/** END: SUPPLEMENT FACTS POPUP MODAL *********************************/


/** START: COLLAPSIBLE INFO *******************************************/
const accordionWrapperHeader = document.querySelectorAll(".accordion-wrapper .c-dropdown-header");
if (accordionWrapperHeader.length) {
    accordionWrapperHeader.forEach( (headerEl) => { 
      headerEl.addEventListener("click", () => {
        const parentEl = headerEl.closest("li");
        const content = parentEl.querySelector("[data-accordion='content']");

        if (parentEl.classList.contains('active')) {
          parentEl.classList.remove('active');
          content.style.maxHeight = null; // Collapse
        } else {
          parentEl.classList.add('active');
          content.style.maxHeight = `${content.scrollHeight + 32}px`; // Expand to fit content
        }
      })
    })
}
/** END: COLLAPSIBLE INFO *********************************************/


/** START: FEATURED LOGOS ********************************************/
let featuredSwiper = new Swiper(".featuredSwiper", {
    loop: true,
    autoplay: {
      delay: 0,
    },
    speed: 1500,
    slidesPerView: 4,
    spaceBetween: 16,
    breakpoints: {
      992: {
        speed: 1000,
        slidesPerView: 6,
        spaceBetween: 32,
      },
      1200: {
        slidesPerView: 8,
        spaceBetween: 32,
      }
    }
});
/** END: FEATURED LOGOS **********************************************/


/** START: WATCH NOW POPUP MODAL *************************************/
const thumbnail = document.getElementById('thumbnail');
const modalv = document.getElementById('videoModal');
const closeModal = document.getElementById('closeModal');
const video = document.getElementById('modalVideo');

// Open modal and play video
thumbnail.addEventListener('click', () => {
    modalv.classList.remove('hidden');
    modalv.classList.add('flex');
    video.play();
});

// Close modal and pause video
closeModal.addEventListener('click', () => {
    modalv.classList.add('hidden');
    modalv.classList.remove('flex');
    video.pause();
    video.currentTime = 0; // reset video
});

// Close modal when clicking outside video
modalv.addEventListener('click', (e) => {
    if (e.target === modalv) {
        modalv.classList.add('hidden');
        modalv.classList.remove('flex');
        video.pause();
        video.currentTime = 0;
    }
});
/** END: WATCH NOW POPUP MODAL ***************************************/


/** START: TESTIMONIALS **********************************************/
let promotesSwiper = new Swiper(".promotesSwiper", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 8,
    autoHeight: false,
    navigation: {
        prevEl: "[data-promote-navigation='prev']",
        nextEl: "[data-promote-navigation='next']",
    },
    on: {
        init: (slide) => {
            if (slide.isBeginning) {
                document.querySelector("[data-promote-navigation='prev']").classList.add("invisible");
            }
        },
        slideChange: (slide) => {
            const prevButton = document.querySelector("[data-promote-navigation='prev']");
            const nextButton = document.querySelector("[data-promote-navigation='next']");
            if (slide.isBeginning) {
                prevButton.classList.add("invisible");
                nextButton.classList.remove("invisible");
            }
            if (slide.isEnd) {
                nextButton.classList.add("invisible");
                prevButton.classList.remove("invisible");
            }
            if (!slide.isEnd && !slide.isBeginning) {
                nextButton.classList.remove("invisible");
                prevButton.classList.remove("invisible");
            }
        }
    },

    pagination: {
        el: ".promote-swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + ' w-[24px] h-[24px] !m-0 bg-transparent text-[#4D311D] text-center font-gt-eesti-pro-display text-[16px] font-light capitalize opacity-100">' + (index + 1) + "</span>";
        },
    },
    breakpoints: {
        992: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
    }
});
/** END: TESTIMONIALS ************************************************/


/** START: TOP REVIEWS **********************************************/
let reviewsSwiper = new Swiper(".reviewsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 8,
    pagination: {
        el: ".reviews-swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + ' w-[20px] h-[20px] !m-0 bg-transparent text-[#4D311D] text-center font-gt-eesti-pro-display md:text-[13.3px] text-[16px] font-light capitalize opacity-100">' + (index + 1) + "</span>";
        },
    },
    breakpoints: {
        992: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
    }
});
/** END: TOP REVIEWS ************************************************/


/** START: COUNTDOWN ************************************************/
const startCountdown = (durationInSeconds) => {
    const timerElement = document.querySelector("[data-timer]");

    let remainingTime = durationInSeconds;

    const updateTimerDisplay = () => {
        const hours = Math.floor(remainingTime / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((remainingTime % 3600) / 60).toString().padStart(2, '0');
        const seconds = (remainingTime % 60).toString().padStart(2, '0');

        timerElement.textContent = `${hours}h : ${minutes}min : ${seconds}sec`;

        if (remainingTime > 0) {
            remainingTime--;
        } else {
            clearInterval(timerInterval);
            timerElement.textContent = "Time's up!";
        }
    }

    updateTimerDisplay();
    const timerInterval = setInterval(updateTimerDisplay, 1000);
}
startCountdown(22049);
/** END: COUNTDOWN **************************************************/


/** START: FAQ TOGGLE ***********************************************/
document.querySelectorAll("[data-faq-accordion='header']").forEach(header => {
    header.addEventListener("click", () => {
      const item = header.closest("li.item");
      const content = item.querySelector("[data-faq-accordion='content']");
      const icon = item.querySelector(".accordion-icon");

      if (content.classList.contains("hidden")) {
        // Open
        content.classList.remove("hidden");
        content.classList.add("flex");
        content.style.maxHeight = "0px";
        
        // Force reflow to ensure the transition starts from 0
        content.offsetHeight;
        
        // Set to a large value to accommodate content
        content.style.maxHeight = content.scrollHeight + "px";
        icon.style.transform = "rotate(-45deg)";
        
        // Clean up after animation
        setTimeout(() => {
          content.style.maxHeight = "none";
        }, 300);
      } else {
        // Close
        content.style.maxHeight = content.scrollHeight + "px";
        
        // Force reflow
        content.offsetHeight;
        
        content.style.maxHeight = "0px";
        icon.style.transform = "rotate(0deg)";
        
        // Hide after animation
        setTimeout(() => {
          content.classList.add("hidden");
          content.classList.remove("flex");
        }, 300);
      }
    });
});
/** END: FAQ TOGGLE *************************************************/


/** START: SMOOTH SCROLLING *****************************************/
// Smooth scroll for anchor tags with href starting with #
document.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
});
/** END: SMOOTH SCROLLING *******************************************/